import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Introduction from "./sections/Introduction";
import CourseOverview from "./sections/CourseOverview";
import Benefits from "./sections/Benefits";
import Testimonials from "./sections/Testimonials";
import PartnerLogos from "./sections/PartnerLogos";
import About from "./sections/About";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Introduction />
      <CourseOverview />
      <Benefits />
      <Testimonials />
      <PartnerLogos />
      <About />
      <Footer />
    </div>;
}